const semanticClassNames = {
  root: 'form',
} as const;

export default semanticClassNames;
